import React from "react";
import { RatingOverviewContext } from "../../context/ratingOverviewContext";
import IRatingAnalytics from "../../interface/iRatingAnalytics";
import RenderQuestionsAnalytics from "./renderQuestionsAnalytics";
import RenderCategoryAnalytics from "./renderCategoryAnalytics";

const RatingAnalytics = (): React.JSX.Element => {
  const {
    ratingAnalytics,
  }: {
    ratingAnalytics: IRatingAnalytics;
  } = React.useContext(RatingOverviewContext);

  return (
    <React.Fragment>
      {Object.keys(ratingAnalytics).length > 0 && (
        <React.Fragment>
          <RenderCategoryAnalytics />

          <RenderQuestionsAnalytics
            questions={ratingAnalytics.speakWithCoachQuestions}
            questionsTitel="Über folgende Themen konnte ich mit meinem Coach sprechen"
          />

          <RenderQuestionsAnalytics
            questions={ratingAnalytics.additionalQuestions}
            questionsTitel="Deine Meinung ist gefragt"
          />
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default RatingAnalytics;
